import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { styled } from '@material-ui/core/styles';
import { Card, Stack, Link, Container, Typography } from '@material-ui/core';
// layouts
import { useTranslation } from 'react-i18next';
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmitSuccess = ({ username }) => {
    navigate({
      pathname: '/login',
      search: `?username=${username}`
    });
  };

  return (
    <RootStyle title={t('pages.forgot_password')}>
      <AuthLayout>
        &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/signup">
          {t('forgot_password.get_started')}
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            {t('forgot_password.cant_remember_password')}
          </Typography>
          <img src="/static/illustrations/illustration_recommender.jpg" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('forgot_password.recover_password')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              {t('forgot_password.enter_details')}
            </Typography>
          </Stack>

          <ForgotPasswordForm onSubmitSuccess={handleSubmitSuccess} />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              {t('forgot_password.dont_have_account')}&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                {t('forgot_password.get_started')}
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
